import { InfoRow } from "../UI";

// טאב "פרטי תיק" לקרן מסוג תיק מנוהל: עמודות הישות מהקובץ
// (מדיניות, יועץ, דמי ניהול, בנק-סניף-חשבון...) + טבלת כל העמודות
// כפי שהן בקובץ, כולל שורות סה"כ (ילין) שאינן חלק מהרכב הנכסים.
export default function ManagedPortfolioTab({ fund, cs }) {
  const mp = fund.managedPortfolio || {};
  const allocations = mp.allocations || [];
  const dmeiNihul = fund.dmeiNihul?.actual?.dmeiTzvPct;

  const th = { textAlign: "right", padding: "7px 10px", fontWeight: 700, fontSize: 11, color: "#64748b", borderBottom: "2px solid #e2e8f0", whiteSpace: "nowrap" };
  const td = { padding: "6px 10px", fontSize: 12, borderBottom: "1px solid #f1f5f9", whiteSpace: "nowrap" };
  const hasTsua = allocations.some(a => a.tsua != null);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 24px" }}>
        <InfoRow label="מדיניות" value={mp.policy} />
        <InfoRow label="יועץ" value={mp.advisor} />
        <InfoRow label="% דמי ניהול חודשי" value={dmeiNihul != null ? `${dmeiNihul}%` : null} />
        <InfoRow label="בנק-סניף-חשבון" value={mp.bankAccount} />
        <InfoRow label="שם ישות" value={mp.accountName} />
        <InfoRow label="מס' ישות / תיק" value={fund.polNum} />
        <InfoRow label="תאריך דוח" value={fund.yitrot?.date} />
      </div>

      {allocations.length > 0 && (
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#f8fafc" }}>
                <th style={th}>אפיק</th>
                <th style={th}>שווי</th>
                <th style={th}>אחוז</th>
                {hasTsua && <th style={th}>תשואה</th>}
              </tr>
            </thead>
            <tbody>
              {allocations.map((a, i) => (
                <tr key={i} style={a.isAggregate ? { background: "#f8fafc" } : undefined}>
                  <td style={{ ...td, fontWeight: a.isAggregate ? 700 : 600, color: a.isAggregate ? "#64748b" : "#0f172a" }}>
                    {a.label}
                  </td>
                  <td style={{ ...td, direction: "ltr", textAlign: "right", fontWeight: a.isAggregate ? 700 : 400 }}>
                    ₪{(a.value || 0).toLocaleString("he-IL", { maximumFractionDigits: 0 })}
                  </td>
                  <td style={{ ...td, direction: "ltr", textAlign: "right" }}>
                    {a.pct != null ? `${a.pct.toFixed(2)}%` : "—"}
                  </td>
                  {hasTsua && (
                    <td style={{ ...td, direction: "ltr", textAlign: "right" }}>
                      {a.tsua != null ? `${a.tsua}%` : "—"}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
